import { useState } from 'react';
import { Pressable, ScrollView, Text, View } from 'react-native';
import { useRouter } from 'expo-router';
import { StyleSheet } from 'react-native-unistyles';
import { Query } from '@/utils/react-query/Queries';
import { DEFAULT_DASHBOARD_SECTIONS } from '@/data/settings';
import OrganizationSetupCard from './OrganizationSetupCard';
import DashboardSettingsModal from './DashboardSettingsModal';
import SolidButton from '@/components/General/SolidButton';
import Unicon from '@/components/General/Unicon';

export default function FreeSetupDashboard({ user }) {
    const [settingsOpen, setSettingsOpen] = useState(false);
    const { data: sections = DEFAULT_DASHBOARD_SECTIONS } = Query.dashboardSections.get({ organizationID: user.organizationID, accountID: user.accountID });
    const router = useRouter();
    return <View style={styles.root}>
        <ScrollView contentContainerStyle={styles.content} keyboardShouldPersistTaps="handled">
            <View style={styles.header}>
                <View style={styles.copy}>
                    <Text style={styles.title}>Welcome to Reach</Text>
                    <Text style={styles.description}>Your people, your giving, your next step.</Text>
                </View>
                <Pressable testID="dashboard-options" accessibilityRole="button" accessibilityLabel="Dashboard settings"
                    style={styles.options} onPress={() => setSettingsOpen(true)}>
                    <Unicon name="options-outline" size={22} colorVariant="textSecondary" />
                </Pressable>
            </View>
            {sections.organizationSetup?.visible !== false && <OrganizationSetupCard user={user} fullWidth />}
            <View style={styles.links}>
                <SolidButton text="Open people directory" iconName="people-outline" iconBefore onPress={() => router.push('/people')} />
                <SolidButton text="Organization setup" variant="muted" onPress={() => router.push('/settings/organization/setup')} />
            </View>
        </ScrollView>
        <DashboardSettingsModal isOpen={settingsOpen} onClose={() => setSettingsOpen(false)}
            loggedInUser={user} sections={sections} setupOnly />
    </View>;
}

const styles = StyleSheet.create(({ colors, fonts, spacing, typography }, { isPortrait }) => ({
    root: { flex: 1, backgroundColor: 'transparent' },
    content: { width: '100%', maxWidth: 800, alignSelf: 'center', padding: spacing.lg, paddingTop: isPortrait ? 80 : spacing.lg, gap: spacing.lg, paddingBottom: spacing.xxl },
    header: { flexDirection: 'row', alignItems: 'center', gap: spacing.md },
    copy: { flex: 1, gap: spacing.xs },
    title: { fontFamily: fonts.heading, fontSize: typography.hero, color: colors.text },
    description: { fontFamily: fonts.body, fontSize: typography.body, color: colors.textSecondary },
    options: { minWidth: 44, minHeight: 44, alignItems: 'center', justifyContent: 'center' },
    links: { alignItems: 'flex-start', gap: spacing.sm },
}));
